module.exports = __webpack_public_path__ + "img/footer_logo.a618cf38.png";